import { useAtom } from 'jotai';
import { avalableROKInApartments, showAvailableState, showFilterOptionsAtom, showROKState } from '../states/planner';
import RadioButton from './RadioButton';

export const FilterOptions = () => {
  const [showFilterOptions] = useAtom(showFilterOptionsAtom);
  const [rokFilter, setRokFilter] = useAtom(showROKState);
  const [availableROK] = useAtom(avalableROKInApartments);
  const [, setShowAvailable] = useAtom(showAvailableState);

  function toggleROK(rok: number) {
    const newRokFilter = [...rokFilter];
    newRokFilter[rok] = !newRokFilter[rok];
    setShowAvailable(true);
    setRokFilter(newRokFilter);
  }

  return (
    <>
      {/* <div
        className={`absolute left-0 top-0 h-full w-full cursor-default ${showFilterOptions ? 'visible' : 'invisible'}`}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && setShowFilterOptions(false)}
        onClick={() => setShowFilterOptions(false)}
      ></div> */}

      <div
        className={`absolute right-2 top-2 w-[115px] transform rounded-md bg-white p-3 shadow-lg transition-all duration-300 ease-out ${
          showFilterOptions ? 'visible scale-100 opacity-90' : 'invisible scale-75 opacity-0'
        }`}
      >
        <ul key="filter-list">
          {rokFilter.map((rok, index) => {
            const roomsAvailable = availableROK[index];
            if (!roomsAvailable) return null;

            return (
              <li key={`rok-${index}`} className="font-style-one mb-2 flex items-center font-bold">
                {index + 1} rok
                <RadioButton checked={rokFilter[index]} action={() => toggleROK(index)} />
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};
